"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _reactSelect = _interopRequireDefault(require("react-select"));
var _styledSystem = require("styled-system");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n"])), props => props.width ? "".concat(props.width, "%") : '100%');
const Label = _styledComponents["default"].label(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  margin: 0 0 ", " 0;\n  & span.required {\n    &:after {\n      content: ' *';\n      color: ", ";\n    }\n  }\n"])), (0, _constant.get)('space.4'), (0, _constant.get)('colors.feedback.danger.normal'));
const fit = (0, _styledSystem.variant)({
  prop: 'fit',
  variants: {
    small: {
      minHeight: (0, _constant.get)('space.32'),
      fontSize: (0, _constant.get)('fontSizes.s'),
      borderRadius: (0, _constant.get)('borderRadius.s'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.8'))
    },
    medium: {
      minHeight: (0, _constant.get)('space.40'),
      fontSize: (0, _constant.get)('fontSizes.m'),
      borderRadius: (0, _constant.get)('borderRadius.m'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.12'))
    },
    large: {
      minHeight: (0, _constant.get)('space.48'),
      fontSize: (0, _constant.get)('fontSizes.l'),
      borderRadius: (0, _constant.get)('borderRadius.m'),
      padding: "".concat((0, _constant.get)('space.0'), " ").concat((0, _constant.get)('space.16'))
    }
  }
});
const variants = {
  fit
};
const StyledSelect = (0, _styledComponents["default"])(_reactSelect["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  .MultiSelect__control {\n    ", "\n  }\n"])), variants.fit);
const LabelContent = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n"])));
const LabelTooltip = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), (0, _constant.get)('space.4'));
const Components = exports.Components = {
  Wrapper,
  Label,
  StyledSelect,
  LabelContent,
  LabelTooltip
};